import './videos.scss'
import PropTypes from 'prop-types'
import Troubleshoot from '../Troubleshoot'
import VideosTable from './VideosTable'
import FavIcon from '../../icons/fav.svg'
import ActiveFavIcon from '../../icons/active_fav.svg'
import Breadcrumb from '../common/Breadcrumb'
import { useTranslation } from 'react-i18next'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import WrappedTabs from '../common/WrappedTabs'
import { useHistory, useLocation } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { trackEvent, gaActions, gaCategories } from '../../utils/ga4'

const Videos = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const stateModel = location.state && location.state.model
  const canGoBack = location.state && location.state.withBackNavigation
  const model = props.model || stateModel
  const hideBreadcrumb = props.hideBreadcrumb
  const hideDisclaimer = props.hideDisclaimer

  const tabs = useMemo(
    () => [
      {
        key: 0,
        slug: 'all-videos',
        title: 'video_context.all_videos',
        labelForGA: 'All Videos',
        content: <VideosTable model={model} hideFilters={props.hideFilters} hideDisclaimer={hideDisclaimer} key="all-videos" />,
      },
      {
        key: 1,
        slug: 'favorites',
        title: 'favorites',
        labelForGA: 'Favorites',
        content: (
          <VideosTable isFavourite={true} model={model} hideFilters={props.hideFilters} hideDisclaimer={hideDisclaimer} key="favourites" hideBreadcrumb />
        ),
      },
    ],
    [model, props.hideFilters, hideDisclaimer],
  )

  const [selectedTab, setSelectedTab] = useState(null)

  useEffect(() => {
    if (!hideBreadcrumb) {
      trackEvent({
        action: gaActions.featureClick,
        category: gaCategories.videosPage,
        label: 'Videos Page: Page View',
      })
    }
  }, [hideBreadcrumb])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const vid = params.get('vid')

    if (!vid) {
      const state = location.state || {}
      if (state.model) {
        const { model: _removed, ...restState } = state
        history.replace({ pathname: location.pathname, search: location.search }, restState)
      }
    }

    const contentParam = params.get('content')
    let activeTab = tabs[0]

    if (contentParam) {
      const match = tabs.find((t) => t.slug === contentParam)
      if (match) activeTab = match
    }

    setSelectedTab(activeTab)
    const expectedParams = new URLSearchParams(location.search)

    if (expectedParams.get('content') !== activeTab.slug) {
      expectedParams.set('content', activeTab.slug)
      history.replace({ pathname: location.pathname, search: `?${expectedParams.toString()}` }, location.state || undefined)
    }
  }, [location.search, location.pathname, location.state, history, tabs])

  const handleTabSwitch = (tabKey) => {
    const tab = tabs.find((t) => t.key === tabKey)
    if (!tab) return
    trackEvent({
      action: gaActions.featureClick,
      category: gaCategories.videosPage,
      label: `Videos Page: Tab Switch - ${tab.labelForGA}`,
    })
    setSelectedTab(tab)
    const params = new URLSearchParams(location.search)
    params.set('content', tab.slug)
    history.replace({ pathname: location.pathname, search: `?${params.toString()}` }, location.state || undefined)
  }
  return (
    <div className="videos-wrapper">
      {!hideBreadcrumb ? (
        <>
          <Breadcrumb path={location.pathname} withBackNavigation={canGoBack} />
          <DashboardHeader headerText={t('nav.videos')} />
          {props.hideFilters && <div className="divider" />}
          <WrappedTabs
            className="main-page-tabs-wrapper"
            tabs={[
              { id: 0, name: tabs[0].title },
              {
                id: 1,
                name: tabs[1].title,
                inactiveIcon: <img src={FavIcon} alt="favourites-inactive" />,
                activeIcon: <img style={{ display: 'inline-block' }} src={ActiveFavIcon} alt="favourites-active" />,
              },
            ]}
            activeTab={selectedTab?.key}
            changeTab={handleTabSwitch}
          />
          {selectedTab?.content}
        </>
      ) : (
        <>
          <DashboardHeader headerText={t('nav.videos')} />
          {props.hideFilters && <div className="divider" />}
          <VideosTable model={model} hideFilters={props.hideFilters} hideDisclaimer={hideDisclaimer} key="favourites" />
        </>
      )}
    </div>
  )
}

Troubleshoot.propTypes = {
  model: PropTypes.string,
}

export default Videos

